export enum CampaignStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ARCHIVED = 'ARCHIVED',
}

export enum CampaignRuleType {
  INACTIVE_DAYS = 'INACTIVE_DAYS',
  NO_GAME_DAYS = 'NO_GAME_DAYS',
  NO_EVENT_DAYS = 'NO_EVENT_DAYS',
}

export enum CampaignIncentiveType {
  NONE = 'NONE',
  COUPON = 'COUPON',
  CREDITS = 'CREDITS',
}

export enum CampaignScheduleFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  ONE_TIME = 'ONE_TIME',
}

export enum CampaignExecutionStatus {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type CampaignScheduleDto = {
  frequency: CampaignScheduleFrequency;
  /** ISO weekday 1=Mon..7=Sun — only used when frequency is WEEKLY */
  dayOfWeek?: number;
  /** Hour in 24h format (0–23) */
  hour: number;
  /** IANA timezone, e.g. "Europe/Paris" */
  timezone: string;
  /** ISO date string — only used when frequency is ONE_TIME */
  runAt?: string;
};

export type CampaignRuleDto = {
  id: string;
  type: CampaignRuleType;
  /** Number of days for the inactivity threshold */
  value: number;
};

export type CampaignExecutionDto = {
  id: string;
  campaignId: string;
  status: CampaignExecutionStatus;
  audienceSize: number;
  sentCount: number;
  failedCount: number;
  openedCount?: number;
  conversionCount?: number;
  createdAt: string;
  completedAt?: string;
};

export type CampaignDto = {
  id: string;
  name: string;
  status: CampaignStatus;
  notificationTitle: string;
  notificationBody: string;
  schedule: CampaignScheduleDto;
  rules: CampaignRuleDto[];
  incentiveType: CampaignIncentiveType;
  couponId?: string;
  creditAmount?: number;
  conversionWindowHours: number;
  nextRunAt?: string;
  lastRunAt?: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
  executions?: CampaignExecutionDto[];
};

export type OverlappingCampaignDto = {
  campaignId: string;
  campaignName: string;
  overlapCount: number;
};

export type AudiencePreviewDto = {
  count: number;
  sampleUserIds: string[];
  overlappingCampaigns?: OverlappingCampaignDto[];
};

export type CampaignAnalyticsDto = {
  totalSent: number;
  totalFailed: number;
  totalOpened: number;
  totalCouponRedeemed: number;
  totalConversions: number;
  conversionRate: number;
};
